export const zeroPad = (input: any, nZeroes: number) => {
    return (input ? input.toString() : '').padStart(nZeroes, '0')
}
